import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { BrandViewModel } from '../business-entities/brand.interface';
import { CallDealerLogEntryRequestModel } from '../business-entities/call-dealer-log-entry-requestModel';
import { SummaryDataService } from '../data-services/summary-data.service';

@Injectable({ providedIn: 'root'})
export class SummaryService {
    brandList: BrandViewModel[] = [];
    constructor(
        private readonly summaryDataService: SummaryDataService
    ) {}

    async getBrand():Promise<Array<BrandViewModel>> {
        await this.summaryDataService
           .getBrand()
           .then(
               (res: GenericResponse<Array<BrandViewModel>>) => {
                   if(res.responseObject) {
                       this.brandList = res.responseObject as Array<BrandViewModel>
                    }
               },
               _err => { // This is intentional 
               }
           );
          
       return this.brandList;
   }
   callDealerLogEntry(request:CallDealerLogEntryRequestModel){
    return this.summaryDataService.callDealerLogEntry(request);
  }
}